function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M15 19.403v-8.54c0-.425-.168-.833-.469-1.133l-2.263-2.263c-.3-.3-.707-.469-1.132-.469h-5.54a1.6 1.6 0 00-1.6 1.6v10.805a1.6 1.6 0 001.6 1.6H13.4a1.6 1.6 0 001.6-1.6z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.002 17.002h3.402a1.6 1.6 0 001.6-1.6V6.86c0-.425-.169-.833-.469-1.133l-2.263-2.263c-.3-.3-.707-.469-1.132-.469H10.6a1.6 1.6 0 00-1.6 1.6v2.402",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.006 6.998h-3.202a.8.8 0 01-.8-.8V2.995M15.002 11H11.8a.8.8 0 01-.8-.8V6.997",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCopyText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCopyText;